import { render, staticRenderFns } from "./DonationsListItem.vue?vue&type=template&id=e468986c&scoped=true&"
import script from "./DonationsListItem.vue?vue&type=script&lang=js&"
export * from "./DonationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./DonationsListItem.vue?vue&type=style&index=0&id=e468986c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e468986c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
